import { Trans, useTranslation } from 'react-i18next'
import Dialog from './Dialog'

interface Props {
  onClose: () => void
  open: boolean
  emailFound?: boolean
}

export default function ForgotPasswordDialog({
  onClose,
  open,
  emailFound = true,
}: Props) {
  const { t } = useTranslation()
  const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL

  if (!emailFound) {
    return (
      <Dialog onClose={onClose} open={open}>
        <p className="custom-heading">
          {t('pages.account.forgotPassword.dialog.emailNotFoundTitle')}
        </p>

        <p className="text-center">
          {t('pages.account.forgotPassword.dialog.emailNotFoundText')}
        </p>

        {supportEmail && (
          <a
            className="block text-center font-bold underline"
            href={`mailto:${supportEmail}`}
          >
            {supportEmail}
          </a>
        )}
      </Dialog>
    )
  }

  return (
    <Dialog dismissible={false} onClose={onClose} open={open}>
      <p className="custom-heading">
        {t('pages.account.forgotPassword.dialog.title')}
      </p>

      <p className="text-center">
        <Trans
          components={{ bold: <span className="font-bold" /> }}
          i18nKey="pages.account.forgotPassword.dialog.text"
        />
      </p>
    </Dialog>
  )
}
